import { useModeContext } from '../context/ModeContext';

export function ModeSwitcher() {
  const { mode, setMode } = useModeContext();

  return (
    <div className="flex bg-neutral-100 rounded-btn p-0.5 text-xs font-medium" role="tablist" aria-label="Mode switcher">
      <button
        role="tab"
        aria-selected={mode === 'consultant'}
        onClick={() => setMode('consultant')}
        className={`flex-1 px-3 py-1.5 rounded-btn transition-all ${
          mode === 'consultant'
            ? 'bg-white text-primary-600 shadow-sm'
            : 'text-neutral-500 hover:text-neutral-700'
        }`}
      >
        Consultant
      </button>
      <button
        role="tab"
        aria-selected={mode === 'assistants'}
        onClick={() => setMode('assistants')}
        className={`flex-1 px-3 py-1.5 rounded-btn transition-all ${
          mode === 'assistants'
            ? 'bg-white text-primary-600 shadow-sm'
            : 'text-neutral-500 hover:text-neutral-700'
        }`}
      >
        My Assistants
      </button>
    </div>
  );
}
